// extracted by mini-css-extract-plugin
export default {"title":"order-details_title__XvH-d","wrapper":"order-details_wrapper__yGbd7"};